<template lang="pug">
div
  .report(v-if='report.visible')
    p(v-if='showItems.animatorName') {{report.animatorName}}
    p(v-if='showItems.activitiesDetails') {{report.activitiesDetails}}
    p(v-if='showItems.appreciationRating') {{report.appreciationRating}}
    p(v-if='showItems.appreciationDetails') {{report.appreciationDetails}}
    p(v-if='showItems.hadBugs') {{report.hadBugs}}
    p(v-if='showItems.bugsDetails') {{report.bugsDetails}}
    p(v-if='showItems.establishment') {{report.establishment}}
    p(v-if='showItems.fromTime') {{report.fromTime}}
    p(v-if='showItems.toTime') {{report.toTime}}
    p(v-if='showItems.participantCount') {{report.participantCount}}
    p(v-if='showItems.remarks') {{report.remarks}}
    p(v-if='showItems.type') {{report.type}}
</template>

<script>
export default {
  props: ['report', 'showItems']
}
</script>
<style>
.report {
  background: white;
  display: flex;
  justify-content: space-between;
}
</style>
